@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.filtersContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0  hevo-toolkit-variables.$spacer * 1.25  hevo-toolkit-variables.$spacer * 0.75;
  min-height: 46px;

  .appliedFiltersContainer {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .filterWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .appliedFilter {
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
    }

    .cloudwatchStatus {
      display: flex;
      align-items: center;
      white-space: pre;

      .editIcon {
        margin-right: -4px;
      }
    }

    .refreshButton {
      margin-right: -4px;
      margin-left: -4px;
    }

    .shimmerBig {
      width: 120px;
      height: 12px;
    }

    .shimmerSmall {
      width: 80px;
      height: 12px;
    }
  }

  &.filtersDialog {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background:  hevo-toolkit-variables.$surface-bg;
    padding: 16px 20px;
  }
}
